import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import "./resultHeader.scss";
import { selectPickLastWinCards } from '../../../redux/3d_game_Slice/gameinfo3d';
import { SelectAnnoucements } from '../../../redux/2d-slice/gameInfo2dSlice';

function ResultHeader3d() {
  let annoucements = useSelector(SelectAnnoucements)
  const lastWinCards = useSelector(selectPickLastWinCards);
  const [digits, setDigits] = useState({
    a: ['0', '0', '0'],
    b: ['0', '0', '0'],
    c: ['0', '0', '0']
  });
  const [latestTime, setLatestTime] = useState('--:-- --');

  useEffect(() => {
    if (!lastWinCards?.[0]) {
      setDigits({
        a: ['0', '0', '0'],
        b: ['0', '0', '0'],
        c: ['0', '0', '0']
      });
      setLatestTime('--:-- --');
      return;
    }

    const [dataPart, timePart] = lastWinCards[0].split('|').map(part => part.trim());
    const values = {};

    dataPart.split('&').forEach(item => {
      const [key, value] = item.split('=');
      values[key.toLowerCase()] = value.padStart(3, '0');
    });

    setDigits({
      a: values.a?.split('') || ['0', '0', '0'],
      b: values.b?.split('') || ['0', '0', '0'],
      c: values.c?.split('') || ['0', '0', '0']
    });

    setLatestTime(timePart ? moment(timePart, 'h:mm:ss A').format('h:mm A') : '--:-- --');
  }, [lastWinCards]);

  const labelColors = {
    A: "#a2da17",
    B: "#01b0f1",
    C: "#FFFF00",
  };



  const renderDigitColumn = (digits, bgColor) => (
    <td width="33.33%">
      <table width="100%">
        <tbody>
          <tr>
            {digits.map((digit, i) => (
              <td width="33.33%" key={`digit-${i}`}>
                <center>
                  <button style={{
                    width: "100%",
                    background: bgColor,
                    color: "red", fontSize: "clamp(14px, 2vw, 24px)",
                    border: "#000 solid 1px",
                    fontWeight: "700"
                  }}>
                    {digit}
                  </button>
                </center>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </td>
  );

  return (
    <>
      <table width="100%" height="100%" border="0">
        <tr>
          <table width="100%" height="100%" border="0">
            <tbody>
              <tr>
                <td width="15%" rowSpan={2}>
                  <div style={{
                    width: "100%",
                    background: "#d9d9d9",
                    color: "#000",
                    textAlign: "center",
                    fontSize: "clamp(14px, 1.8vw, 20px)",
                    border: "#000 solid 1px"
                  }}>
                    <b>L-Draw<br />{latestTime}</b>
                  </div>
                </td>
                <td width="80%">
                  <table width="100%">
                    <tbody>
                      <tr>
                        {['A', 'B', 'C'].map((label) => (
                          <td width="33.33%" key={`label-${label}`}>
                            <center>
                              <button
                                style={{
                                  width: "100%",
                                  background: labelColors[label], // 🎨 dynamic color
                                  color: "#000",
                                  fontSize: "clamp(14px, 1.8vw, 20px)",
                                  border: "#000 solid 1px",
                                  fontWeight: "bold",
                                  cursor: "pointer"
                                }}
                              >
                                {label}
                              </button>
                            </center>
                          </td>
                        ))}

                      </tr>
                    </tbody>
                  </table>

                  <table width="100%" style={{ marginTop: "-2px" }}>
                    <tbody>
                      <tr>
                        {renderDigitColumn(digits.a, "#a2da17")}
                        {renderDigitColumn(digits.b, "#01b0f1")}
                        {renderDigitColumn(digits.c, "#FFFF00")}
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </tr>

        <tr>
          <table width="100%" style={{ marginTop: "-2px" }}>
            <tbody>
              <tr>
                <td width="100%" style={{ background: "#c0504e" }}>
                  <marquee width="100%" direction="left" scrollamount="7" style={{
                    fontSize: "18px",
                    color: "#fff",
                    fontWeight: "500 !important",
                    marginBottom: "0px"
                  }}>
                    {annoucements}
                  </marquee>
                </td>
              </tr>
            </tbody>
          </table>
        </tr>
      </table>
    </>
  );
}

export default ResultHeader3d;